import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { AppRoutes } from '../../routes';
import { AddUserOrganization } from './AddUser/AddUserOrganization';
import { EditUserInfo } from './EditUser/EditUserInfo';
import { ManageUser } from './ManageUser';

export const UserManagement: React.FC = () => (
            <Switch>
                <Route exact path={AppRoutes.ManageUser} component={ManageUser} />
                <Route exact path={AppRoutes.AddUser} component={AddUserOrganization} />
                <Route exact path={AppRoutes.User} component={EditUserInfo} />
            </Switch>
    )
